import { useEffect, useRef } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { useField } from 'formik'

type Props = {
  name: string
  sitekey: string
  language?: string // e.g. nl, en
}

export const CaptchaInput = ({ name, language, sitekey }: Props) => {
  const captchaRef = useRef<ReCAPTCHA>(null)
  const captchaInstanceNr = useRef<number>(1)

  const [, , helpers] = useField<string | null>(name)

  useEffect(() => {
    if (captchaRef.current) {
      // Workaround to rerender captcha on language changes

      // eslint-disable-next-line no-plusplus
      captchaInstanceNr.current++
      captchaRef.current.reset()
    }
  }, [language])

  return (
    <div className="captcha">
      <ReCAPTCHA
        key={captchaInstanceNr.current}
        // @ts-ignore
        ref={captchaRef}
        hl={language}
        sitekey={sitekey}
        onChange={(value) => helpers.setValue(value, true)}
        // @ts-ignore ignore the window.grecaptcha error
        grecaptcha={window.grecaptcha}
        size="compact"
      />
    </div>
  )
}
